import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { SpinnerLayoutComponent } from './spinner-layout/spinner-layout.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HeaderHifptComponent } from './header-hifpt/header-hifpt.component';
import { FooterHifptComponent } from './footer-hifpt/footer-hifpt.component';
import { RouterModule } from '@angular/router';
import { DetailPopupComponent } from './detail-popup/detail-popup.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ConfirmDialogComponent,
    SpinnerLayoutComponent,
    HeaderHifptComponent,
    FooterHifptComponent,
    DetailPopupComponent
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    SlickCarouselModule,
    RouterModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SpinnerLayoutComponent,
    FooterHifptComponent,
    HeaderHifptComponent,
  ],
})
export class SwapWifiSharedModuleModule {}
